module.exports={
    "ASIA_LIVE_EVENT": "アジア イベント",
    "ASIA_TV": "アジア TV",
    "AUS_TV": "オーストラリア TV",
    "CURRENT_STREAM": "選択中のチャンネル",
    "EMEA_LIVE_EVENT": "ヨーロッパ イベント",
    "EUROPE_TV": "ヨーロッパ TV",
    "FOR_YOU": "最新ビデオ",
    "GUESTS": "ゲスト",
    "LIVE_NOW": "再生中",
    "LIVE_ON_BLOOMBERG": "ブルームバーグ テレビ ライブ放送",
    "LIVE_TV": "TVライブ放送",
    "NOW_PLAYING": "再生中",
    "POLITICS_LIVE_EVENT": "政治ライブイベント",
    "STREAM_SCHEDULE": "番組表",
    "UP_NEXT": "次の番組",
    "US_LIVE_EVENT": "米国 イベント",
    "US_TV": "米国 TV",
    "US_TV_PHOENIX": "米国 TV",
    "US_BTV": "米国 TV",
    "WATCH_NOW": "ライブ放送を見る",
    "404_DESCRIPTION": "お探しのページが見つかりません",
    "404_BUTTON_TEXT": "トップページはこちら",
    "500_DESCRIPTION": "サーバーに予期せぬ内部サーバーエラーが発生しました。問題が続くようでしたら、お手数ですがエラーの内容とともに問題をご報告ください。",
    "SEE_FULL_SCHEDULE": "プログラム番組表"
}
